require('./drawer.scss');
function init(){
    $('.fade.modal-drawer').removeClass('render-content');
}

init();

module.exports = {
    init:init
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/drawer/drawer.js
// module id = 108
// module chunks = 0 1 3 6 8 11 12 14 18